import { render, staticRenderFns } from "./AttendanceSetting.vue?vue&type=template&id=67447110&scoped=true"
import script from "./AttendanceSetting.vue?vue&type=script&lang=js"
export * from "./AttendanceSetting.vue?vue&type=script&lang=js"
import style0 from "./AttendanceSetting.vue?vue&type=style&index=0&id=67447110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67447110",
  null
  
)

export default component.exports